import { useEffect } from 'react'

import Api from 'services/api'

import { useStoreContext } from 'hooks/StoreContext'

const useSystemReports = (deviceId) => {
  const {
    systemReports,
    setSystemReports,
    areSystemReportsLoaded,
    setAreSystemReportsLoaded
  } = useStoreContext()

  useEffect(() => {
    setAreSystemReportsLoaded(false)
    setSystemReports(null)

    Api.SystemReports.list(deviceId)
      .then((response) => {
        setSystemReports(response)
      })
      .catch(() => {
        setSystemReports(null)
      })
      .finally(() => {
        setAreSystemReportsLoaded(true)
      })
  }, [deviceId, setSystemReports, setAreSystemReportsLoaded])

  return { systemReports, areSystemReportsLoaded }
}

export default useSystemReports
